import { AlertTriangle, ArrowLeft, Home, RefreshCw, ShieldX } from "lucide-react";
import { isRouteErrorResponse, Link, useNavigate, useRouteError } from "react-router";
import { Button } from "@/components/ui/button";

export function ErrorPage() {
	const error = useRouteError();
	const navigate = useNavigate();

	let statusCode = 500;
	let title = "Error inesperado";
	let message = "Ha ocurrido un error. Por favor, intente de nuevo.";
	let Icon = AlertTriangle;

	if (isRouteErrorResponse(error)) {
		statusCode = error.status;

		if (error.status === 404) {
			title = "Pagina no encontrada";
			message = "La pagina que busca no existe o ha sido movida.";
		} else if (error.status === 403) {
			title = "Acceso denegado";
			message = "No tiene permisos para acceder a esta pagina.";
			Icon = ShieldX;
		} else if (error.status === 401) {
			title = "Sesion expirada";
			message = "Su sesion ha expirado. Por favor, inicie sesion nuevamente.";
			Icon = ShieldX;
		} else if (error.status >= 500) {
			title = "Error del servidor";
			message = "Ocurrio un problema en el servidor. Por favor, intente mas tarde.";
		}
	} else if (error instanceof Error) {
		// biome-ignore lint/suspicious/noConsole: Error logging for debugging/monitoring
		console.error("Application error:", error);
		message = import.meta.env.DEV ? error.message : message;
	}

	const handleRetry = () => {
		void navigate(0); // Reload current route
	};

	const handleGoBack = () => {
		void navigate(-1);
	};

	return (
		<div
			className="min-h-svh flex items-center justify-center bg-background"
			role="main"
			aria-labelledby="error-title"
		>
			<div className="text-center space-y-6 p-4 max-w-md">
				<div className="flex justify-center">
					<div className="rounded-full bg-destructive/10 p-4">
						<Icon className="size-12 text-destructive" aria-hidden="true" />
					</div>
				</div>

				<div className="space-y-2">
					<p className="text-7xl font-bold text-muted-foreground" aria-hidden="true">
						{statusCode}
					</p>
					<h1 id="error-title" className="text-2xl font-semibold">
						{title}
					</h1>
					<p className="text-muted-foreground">{message}</p>
				</div>

				<div className="flex items-center justify-center gap-3 flex-wrap">
					<Button variant="outline" onClick={handleGoBack}>
						<ArrowLeft className="mr-2 size-4" aria-hidden="true" />
						Volver
					</Button>

					{statusCode >= 500 && (
						<Button variant="outline" onClick={handleRetry}>
							<RefreshCw className="mr-2 size-4" aria-hidden="true" />
							Reintentar
						</Button>
					)}

					<Button asChild>
						<Link to="/dashboard">
							<Home className="mr-2 size-4" aria-hidden="true" />
							Ir al Dashboard
						</Link>
					</Button>
				</div>

				{import.meta.env.DEV && error instanceof Error && error.stack && (
					<details className="mt-8 text-left">
						<summary className="cursor-pointer text-sm text-muted-foreground hover:text-foreground">
							Detalles del error (solo desarrollo)
						</summary>
						<pre className="mt-2 overflow-auto rounded bg-muted p-4 text-xs">{error.stack}</pre>
					</details>
				)}
			</div>
		</div>
	);
}
